import { render, staticRenderFns } from "./FieldTable.vue?vue&type=template&id=71683a8a"
import script from "./FieldTable.ts?vue&type=script&lang=ts&external"
export * from "./FieldTable.ts?vue&type=script&lang=ts&external"
import style0 from "./FieldTable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports